import React from "react";
import { Link } from "react-router-dom";
import DOMPurify from "dompurify";

import { LoggedIn } from "../../utils/helper";
import Divider from "./divider";
import Reveal from "./reveal";
import { LuMedal } from "react-icons/lu";
import { GiHouse } from "react-icons/gi";
import { BsHeart } from "react-icons/bs";
import EditLink from "./edit-link";
import "./card.css";

const STATIC_URL = process.env.REACT_APP_STATIC_URL;

const Card = ({ posts, id, expansionLink }) => {
  const userLoggedIn = LoggedIn();
  const [header, ...details] = posts;
  return (
    <>
      <div
        id={id}
        className="aboutContainer"
        style={{
          backgroundImage: "url(" + `${STATIC_URL}/about-bg.jpg` + ")",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          padding: 0,
          position: "relative",
        }}
      >
        <div id={id} className="aboutSubContainer">
          {/* HEADING OF SECTION */}
          <div className="heading">
            <div>
              {header && <EditLink id={header.id} />}
              <div className="headerTitle">{header && header.title}</div>
              <Divider />
              <div
                className="headerText"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(header && header.desc),
                }}
              ></div>
            </div>
          </div>

          {/* DETAIL OF SECTION */}
          <div
            id={id === "services" ? "servicelist" : ""}
            className={id === "services" ? "detail collapse" : "detail"}
          >
            <div className="cardsContainer">
              {details.map((post, index) => (
                <div className="cardContainer" key={post.id}>
                  <Reveal
                    column={index}
                    card={
                      <div className="cardRecord">
                        {post.id && (
                          <div className="cardBody">
                            <div className="iconBorder">
                              {post &&
                                (post.more == "LuMedal" ? (
                                  <LuMedal className="icon" size={35} />
                                ) : post.more == "BsHeart" ? (
                                  <BsHeart className="icon" size={35} />
                                ) : post.more == "GiHouse" ? (
                                  <GiHouse className="icon" size={35} />
                                ) : null)}
                            </div>

                            {post && <EditLink id={post.id} />}

                            {post.img && (
                              <div className="teamImg">
                                <img
                                  src={`${STATIC_URL}/${post.img}`}
                                  alt={post.title}
                                />
                              </div>
                            )}

                            <div className="cardHeader">{post.title}</div>
                            <div
                              className="cardText"
                              dangerouslySetInnerHTML={{
                                __html: DOMPurify.sanitize(post.desc),
                              }}
                            ></div>
                          </div>
                        )}
                      </div>
                    }
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Card;
